import CLIENTS_WITHOUT_LINKING from "../../const/clientsWithoutLinking";
var isAccountLinkDisabledForAClient = function (clientId) {
    return CLIENTS_WITHOUT_LINKING.includes(clientId);
};
export default isAccountLinkDisabledForAClient;
//# sourceMappingURL=isAccountLinkDisabledForAClient.js.map